import { createFileRoute } from '@tanstack/react-router'

import { DocumentProvider } from '@/modules/documents'
import { DocumentLayout } from '@/modules/documents/pages'

export const Route = createFileRoute('/_authenticated/documents/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  return (
    <DocumentProvider>
      <DocumentLayout id={id} />
    </DocumentProvider>
  )
}
